"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastDeclarativeExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/toast/examples/declarative.ts';
var ToastDeclarativeExample = /** @class */ (function () {
    function ToastDeclarativeExample() {
        var _this = this;
        this.notifications = [];
        this.timeout = 3000;
        this.show = function () {
            _this.notifications.push({
                message: 'Toast message',
                key: Date.now()
            });
        };
        this.dismiss = function (key) {
            var index = _this.notifications.findIndex(function (x) { return x.key === key; });
            _this.notifications.splice(index, 1);
        };
    }
    ToastDeclarativeExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                label: 'Show toast',
                intent: 'primary',
                onclick: this.show
            }),
            (0, mithril_1.default)(_1.Toaster, {
                toasts: this.notifications.map(function (notification) { return (0, mithril_1.default)(_1.Toast, {
                    key: notification.key,
                    message: notification.message,
                    onDismiss: _this.dismiss,
                    timeout: _this.timeout
                }); })
            })
        ]);
    };
    ToastDeclarativeExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.timeout === 0,
                label: 'Timeout = 0',
                onchange: function () { return _this.timeout = _this.timeout === 0 ? 3000 : 0; }
            })
        ];
    };
    return ToastDeclarativeExample;
}());
exports.ToastDeclarativeExample = ToastDeclarativeExample;
